export class AbstractKappasFlattenRecon {

  constructor(application?: number, projectNumber?: string,
    fY?: number, type?: number, mechanism?: string, statusDate?: string,
    projectTitle?: string, pIName?: string, descPart?: string, publicHealthPart?: string, hasNotes?: string,
    inQcList?: string, reviewRequested?: string, adjudicationRequested?: string, submissionAgreePriorityTitle?: string,
    subcategoryGroupTitle?: string, teamcoders?: string, notes?: string) {

    this.ApplicationID = application;
    this.ProjectNumber = projectNumber;
    this.FY = fY;
    this.Type = type;
    this.Mech = mechanism;
    this.StatusDate = statusDate;
    this.Title = projectTitle;
    this.PIName = pIName;
    this.Description = descPart;
    this.PublicHealthPart = publicHealthPart;   
    this.InQcList = inQcList;
    this.ReviewRequested = reviewRequested;
    this.AdjudicationRequested = adjudicationRequested;
    this.HasNotes = hasNotes;
    this.Notes = notes;   
    this.SubmissionAgreePriorityTitle = submissionAgreePriorityTitle;
    this.SubcategoryGroupTitle = subcategoryGroupTitle;
    this.Coders = teamcoders;
    
  }

  public ApplicationID: number;
  public ProjectNumber: string;
  public FY: number;
  public Type: number;
  public Mech: string;
  public StatusDate: string;
  public PIName: string;
  public Title: string;
  public Description: string;
  public PublicHealthPart: string;  
  public InQcList: string;
  public ReviewRequested: string;
  public AdjudicationRequested: string;
  public HasNotes: string;
  public Notes: string;
  public SubmissionAgreePriorityTitle: string;
  public SubcategoryGroupTitle: string;
  public Coders: string;
  

}

